import React from 'react';
import StudentMyLearning from '../components/studentMyLearning';
function StudentMyLearningPage() {
    return <StudentMyLearning />;
}

export default StudentMyLearningPage;
